import React, { useContext, useState } from "react";
import {
  Row,
  Nav,
  TabContent,
  TabPane,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";
import classNames from "classnames";
import BrushButton from "./BrushButton";
import PenButton from "./PenButton";
import { RootStoreContext } from "../../../app/stores/rootStore";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../../app/localization/localization";

interface IParams {
  isBrushEnabled: boolean;
  isPenEnabled: boolean;
  isZoomed: boolean;
  id: string;
}

export const DropdownPenBrushButton: React.FC<IParams> = ({
  isBrushEnabled,
  isPenEnabled,
  isZoomed,
  id,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { toolbar, theme } = rootStore.commonStore;
  const [disegnaDropdownOpen, setDisegnaDropdownOpen] = useState(false);
  const [t] = useTranslation(["browse_page"], translationHookOptions);

  const toggleDisegna = () => setDisegnaDropdownOpen(!disegnaDropdownOpen);

  if (!toolbar) return <></>;
  const { tools } = toolbar;
  return (
    <>
      {tools.pen && !tools.marker && (
        <div className="divButton" id={id}>
          <PenButton />
        </div>
      )}
      {tools.marker && !tools.pen && (
        <div className="divButton" id={id}>
          <BrushButton />
        </div>
      )}
      {tools.marker && tools.pen && (
        <ButtonDropdown
          id={id}
          isOpen={disegnaDropdownOpen}
          toggle={toggleDisegna}
          className={classNames(
            " transparentButton dropdownButton dropdownDiv"
          )}
          style={{ display: "none" }}
        >
          <DropdownToggle
            color="none"
            className={classNames(
              " transparentButton dropdownButton",
              isBrushEnabled || isPenEnabled
                ? `${theme!.toolbarActiveIconColor}`
                : `${theme!.toolbarIconColor}`
            )}
            disabled={isZoomed}
          >
            {!isBrushEnabled && !isPenEnabled ? (
              <i className="fas fa-highlighter iconToolbarButton"></i>
            ) : null}
            {isBrushEnabled ? (
              <i className="fas fa-highlighter iconToolbarButton"></i>
            ) : null}
            {isPenEnabled ? (
              <i className="fas fa-pencil-alt iconToolbarButton"></i>
            ) : null}
            <i className="fas fa-sort-down"></i>
            <h6 className="textToolbarButton mb-0">
              {t("toolbar_draw_dropdown")}
            </h6>
          </DropdownToggle>
          <DropdownMenu
            className={classNames(
              "dropdownMenu",
              `${theme!.toolbarBackground}`
            )}
          >
            <div className="divButton">
              <BrushButton />
            </div>
            <div className="divButton">
              <PenButton />
            </div>
          </DropdownMenu>
        </ButtonDropdown>
      )}
    </>
  );
};
